import {ChangeDetectionStrategy, Component, computed, inject, ViewEncapsulation} from '@angular/core';
import {LoaderService} from '../../services/loader.service';
import {CssPositionEnum} from '../../enums/CssPositionEnum';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpinnerComponent {
  public CssPositionEnum = CssPositionEnum;
  public hasTitle = computed(() => this.loadingItem()?.title !== '');
  public hasDescription = computed(() => this.loadingItem()?.description !== '');
  public hasContent = computed(() => this.hasTitle() || this.hasDescription());
  private loader = inject(LoaderService);
  public loadingItem = this.loader.loadingItem;
}
